<template>
    <nav class="tabs is-boxed is-fullwidth">
        <div class="container">
        <ul>
            <li>
                <router-link to="/novedades" :class="{'tab-mix news no-border-right':true, 'is-active':currentPage=='news'}">
                    <span class="icon is-small"><fa icon="newspaper" /></span>
                    <span class="mu-font is-uppercase">Novedades</span>
                </router-link>
            </li>
            <!-- <li>
                <a class="tab-mix no-border-left no-border-right">
                    <span class="icon is-small"><fa icon="hand-holding-medical" /></span>
                    <span class="mu-font is-uppercase">Guias</span>
                </a>
            </li> -->
            <li>
                <router-link to="/comandos" :class="{'tab-mix commands no-border-left no-border-right':true, 'is-active':currentPage=='commands'}">
                    <span class="icon is-small"><fa icon="code" /></span>
                    <span class="mu-font is-uppercase text">Comandos</span>
                </router-link>
            </li>
            <li>
                <router-link to="/ranking" :class="{'tab-mix ranking no-border-left no-border-right':true, 'is-active':currentPage=='ranking'}">
                    <span class="icon is-small"><fa icon="trophy" /></span>
                    <span class="mu-font is-uppercase text">Ranking</span>
                </router-link>
            </li>
            <!-- <li>
                <a class="tab-mix no-border-left no-border-right">
                    <span class="icon is-small"><fa icon="image" /></span>
                    <span class="mu-font is-uppercase">Artes</span>
                </a>
            </li>
            <li>
                <router-link to="/mercado" :class="{'tab-mix store no-border-left':true, 'is-active':currentPage=='store'}">
                    <span class="icon is-small"><fa icon="shopping-cart" /></span>
                    <span class="mu-font is-uppercase">Mercado</span>
                </router-link>
            </li> -->
        </ul>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'HeroFootTabs',
    props: ['currentPage']
}
</script>

<style scoped>
.tab-mix {
    background-color: rgba(10, 10, 10, 0.7) !important;
    transition: background-color .6s;
}
.tab-mix:hover{
    background-color: rgba(10, 10, 10, 0.9) !important;
}
.tab-mix.ranking.is-active{
    background-color: rgb(50, 115, 220, .8) !important;
}
.tab-mix.commands.is-active {
    background-color: rgba(184, 184, 184, 0.993) !important;
}
.tab-mix.news.is-active{
    background-color: rgba(252, 215, 19, .8) !important;
}
/* .tab-mix.is-active > .text, .tab-mix.is-active > .icon {
    color: hsl(0, 0%, 21%) !important;
} */
.no-border-left {
    border-top-left-radius: inherit !important;
}
.no-border-right {
    border-top-right-radius: inherit !important;
}
</style>